<template>
<div>
    <CCol sm="12">
        <CCard>
            <CCardBody class="d-flex flex-column">
                <div class="d-flex mb-2 justify-content-end align-items-start">
                    <!-- Title -->
                    <p class="flex-grow-1">{{ $t('category') }}</p>
                    <!-- Language dropdown -->
                    <LanguageDropdown v-model="currentLanguage"></LanguageDropdown>
                </div>
                <!-- Form -->
                <!-- Names -->
                <div role="group" class="form-group">
                <label class=""> {{ $t('nameMandatory') }}</label>
                    <CInput type="text" v-model="category.names[currentLanguage.key]" :invalid-feedback="errorOutput['Names']" :is-valid="genericValidator(category.names, attemptedSubmit) && errorValidator('Names')"></CInput>
                </div>
                <!-- Brand -->
                <div v-if="(category.type == 'Product' || categoryType == 2) && !isUpdate" role="group" class="form-group">
                <label class=""> {{ $t('brandMandatory') }}</label>
                    <SingleOptionDropdown v-model="category.brand" :options="brandOptions" :title="$t('brand')" :index="0" :is-valid="genericValidator(category.brand, attemptedSubmit) && errorValidator('Brand')" :invalid-feedback="errorOutput['Brand']"></SingleOptionDropdown>
                </div>
                <!-- Parent -->
                <div v-if="!isUpdate || category.parentId != null" role="group" class="form-group" :class="{'disabled': (category.type == 'Product' || categoryType == 2) && !category.brand}">
                <!-- <div v-if="!isUpdate || category.parentId != null" role="group" class="form-group"> -->
                    <label class=""> {{ $t('parentMandatory') }}</label>
                    <SingleOptionDropdown v-model="category.parentId" :options="parentCategories" :title="$t('parent')" :index="0" :is-valid="errorValidator('ParentId')" :invalid-feedback="errorOutput['ParentId']"></SingleOptionDropdown>
                </div>
                <!-- Action button + submitting -->  
                <CSpinner v-if="submitting" variant="success" small class="align-self-end"></CSpinner>
                <CButton v-else type="button" class="btn btn-primary align-self-end" @click="submitClicked">{{ $t('acceptChanges') }}</CButton>
                <!-- Loading -->
                <FormLoading v-if="loading"></FormLoading>
            </CCardBody>
        </CCard>
    </CCol>
    <ConfirmationPopUp :confirmationMessage="confirmationMessage" @closeConfirmRequested="onClickConfirmationPopup" v-model="showConfirmationPopup"></ConfirmationPopUp>
</div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import router from '@/router/index';

import { deepClone } from "@/helpers/utils.js";
import { CONSTANTS } from '@/helpers/consts';
import { genericValidator, errorValidator } from "@/helpers/utils.js";

import InputGetList from "@/classes/InputGetList";
import Category from "@/classes/Category";

import LanguageDropdown from '@/controls/LanguageDropdown.vue'
import ConfirmationPopUp from "@/controls/popups/ConfirmationPopUp.vue";
import SingleOptionDropdown from '@/controls/SingleOptionDropdown.vue'
import FormLoading from '@/controls/FormLoading.vue'

  export default {
        components: { LanguageDropdown, ConfirmationPopUp, SingleOptionDropdown, FormLoading },
    props:{    
        baseCategory:
        {
            type: Object,
            default: null,
        },
        baseName:
        {
            type: String,
            default: null,
        },
        loading:
        {
            type: Boolean,
            default: false,
        },
        isUpdate:
        {
            type: Boolean,
            default: false
        },
        categoryType:{
            type: Number,
            default: 2
        }

    },
    data()
    {
        return {
            attemptedSubmit: false,
            currentLanguage: CONSTANTS.supportedLanguages[0],
            category: new Category({}),
            submitting: false,
            showConfirmationPopup: false,
            confirmationMessage:"",
            //
            typeOptions: [{label: this.$t("blog"), key: "Blog"}, {label: this.$t("product"), key: "Product"}],
            brandOptions: [{label: this.$t("inflateYourImagination"), key: "InflateYourImagination"}, {label: this.$t("activeBrands"), key: "ActiveBrands"}],
            levelOptions: [{label: this.$t("parent"), key: "Parent"}, {label: this.$t("child"), key: "Child"}],
        }
    },
    mounted: function()
    {
        this.resetCategory();            
    },
    computed:
    {
        ...mapState('categories', ['getCategoriesOutput']),
        ...mapState('categories', ['putCategoryOutput']),
        ...mapState('categories', ['postCategoryOutput']),
        ...mapState({ 
            alertType: state => state.alert.type,
            alertOutput: state => state.alert.output
        }),
        errorOutput: function()
        {
            var result = this.alertOutput && Array.isArray(this.alertOutput) ? this.alertOutput : [];

            // Validate multi language fields
            for (const [key, value] of Object.entries(this.category.names)) { if(!value) { result['Names'] = this.$i18n.t("validateBothTranslations"); break; }; }

            return result;
        },
        name: function () {
            return this.baseCategory || this.baseName ? (this.baseCategory ? this.baseCategory.name : this.baseName) : null;
        },
        categoriesInfo: function() {
            return this.getCategoriesOutput && this.getCategoriesOutput.data ? this.getCategoriesOutput.data : null;
        },
        parentCategories: function()
        {
            var result = [];

            if(this.categoriesInfo)
            {
                this.categoriesInfo.forEach(category => 
                {
                    result.push({key: category.id, label: category.name });
                });
            }

            return result;
        },
    },
    methods:{
        ...mapActions('categories', ['getCategories']),
        genericValidator,
        errorValidator,
        resetCategory(){
            if(!this.baseCategory)
            {
                var names = {}; 
                CONSTANTS.supportedLanguages.forEach(language => { names[language.key] = "";  });
                this.category = new Category(names);
            }
            else
            {
                this.category = deepClone(new Category, this.baseCategory);   
            }
        },
        submitClicked(){
            this.attemptedSubmit = true;

            this.category.type = this.categoryType;
            this.category.level = this.category.parentId != null ? 2 : 1;

            // Emit event
            if(this.category.isValid())
            {
                this.submitting = true;
                this.$emit('submit-requested', this.category);
            }
        },
        onClickConfirmationPopup(value){
            this.showConfirmationPopup = value;     
            router.push({name: "CategoriesList"});
        },
        onProcessTask: function(val)
        {
            if(val != null)
            {
                if(val)
                {
                    this.showConfirmationPopup = true;
                }

                this.submitting = false;
            }
        }
    },
    watch:
    {
        "category.parent.id": function(val)
        {
            this.category.parentId = val;
        },
        putCategoryOutput: function(val)
        {
            this.onProcessTask(val);
        },
        postCategoryOutput: function(val)
        {
            this.onProcessTask(val);
        },
        baseCategory: function()
        {
            this.resetCategory();            
        },
        alertOutput: function()
        {
            // Show pop up in case it is a string error
            // In case it is an array, it is shown on the field
            if(typeof this.alertOutput === 'string' || this.alertOutput instanceof String)
            {
                alert(this.alertOutput);
            }
        },
        "category.brand": function()
        {
            // Get parent categories
            const itemsPerPage = 999;
            const currentPage = 1;
            const searchText = null;
            const sorter = 2; // DESC
            const sorterColumn = "Name";

            var input = new InputGetList(itemsPerPage, currentPage, searchText, sorter, sorterColumn);
            input.level = 1; // Parent
            input.type = this.categoryType;
            input.brand = this.category.brand

            this.getCategories(input);  
        }
    }
  }
</script> 